module.exports = __webpack_public_path__ + "img/add-titles-info.b9e9d879.png";